import { ProductOption, ProductCustomService } from '../product/customer-product';
import { Cart, CartItem, RentalCartItem, SaleCartItem } from './cart';
import { ExcludeProductFeeRequest } from '../../quipli-service/financials/financials';
import { DateTime } from 'luxon';
import { CustomerProductParsers } from '../product/customer-product-parsers';

export namespace CartParsers {
  export class CartJson {
    id!: string;
    readonly userId?: number;
    readonly sessionId!: string;
    readonly items!: CartItemJson[];
    readonly meta?: {
      readonly coupon?: string;
      readonly excludeFeeIds?: number[];
      readonly excludeProductFees?: ExcludeProductFeeRequest[];
      readonly excludeDamageWaiver?: boolean;
    };
  }

  export class CartItemJson {
    readonly id!: string;
    readonly cartId!: string;
    readonly type!: string;
    readonly product!: CustomerProductParsers.CustomerProductJson;
    readonly quantity!: number;
    readonly shippingType?: string;
    readonly options!: Record<string, string>;
    // rental only
    readonly startDate?: string;
    readonly endDate?: string;
    // sale only
    readonly services?: ServiceJson[];
  }

  export class ServiceJson {
    readonly id!: number;
    readonly value!: string;
  }

  export function toCart(input: CartJson): Cart {
    return {
      id: input.id,
      userId: input.userId,
      sessionId: input.sessionId,
      items: input.items.map(toCartItem),
      meta: {
        coupon: input.meta?.coupon,
        excludeFeeIds: input.meta?.excludeFeeIds,
        excludeProductFees: input.meta?.excludeProductFees,
        excludeDamageWaiver: input.meta?.excludeDamageWaiver,
      },
    };
  }

  export function toCartItem(input: CartItemJson): CartItem {
    if (input.type === 'Rental') {
      return new RentalCartItem(
        input.id,
        input.cartId,
        CustomerProductParsers.toCustomerProduct(input.product),
        input.quantity,
        input.options,
        DateTime.fromISO(input.startDate!, { setZone: true }),
        DateTime.fromISO(input.endDate!, { setZone: true }),
      );
    } else {
      return new SaleCartItem(
        input.id,
        input.cartId,
        CustomerProductParsers.toCustomerProduct(input.product),
        input.quantity,
        input.options,
        input.services?.map(toService) ?? [],
        // input.services?.map(toService) ?? [],
      );
    }

    function toService(input: ServiceJson): { id: number; value: string } {
      return {
        id: input.id,
        value: input.value,
      };
    }
  }

  export class ProductOptionJson {
    id!: number;
    productId!: number;
    optionId!: number;
    name!: string;
    required!: boolean;
    values?: { id: number; name: string }[];
  }
  export class ProductCustomServiceJson {
    id!: number;
    productId!: number;
    serviceId!: number;
    name!: string;
    image?: string;
    options?: string[];
    price!: number;
  }
  export class CustomizationsJson {
    options!: ProductOptionJson[];
    services!: ProductCustomServiceJson[];
  }

  export function toCartCustomizations(input: CustomizationsJson): {
    options: ProductOption[];
    services: ProductCustomService[];
  } {
    return {
      options: input.options,
      services: input.services,
    };
  }
}
